export const DEFAULT_CONFIG = {
  length: 15,
  includeLetters: true,
  includeDigits: true,
  includeSymbols: true,
}

export const SYMBOL_SET = "!@#$%^&*()-_=+[]{};:,.<>?/|~"
export const LETTER_SET = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
export const DIGIT_SET = "0123456789"
